/* eslint arrow-body-style: ["error", "always"] */
/* eslint jsx-a11y/anchor-has-content: 0 */

import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { SparkModal } from '../ui/spark';
import AddToBody from './AddToBody';

class ReactSparkModal extends Component {
    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this._callbackOnClose = this._callbackOnClose.bind(this);
    }

    componentDidMount() {
        this.modalInstance = new SparkModal(this.node);
        this.modalInstance.callbackOnClose = this._callbackOnClose;
        if (typeof this.props.onBeforeClose === 'function') {
            const originalClose = this.modalInstance.close;
            this.modalInstance.setParams(
                {
                    close: () => {
                        if (this.props.onBeforeClose() !== false) {
                            return originalClose.call(this.modalInstance);
                        }
                        return this.modalInstance;
                    }
                },
                true
            );
        }
        if (typeof this.props.onAfterClose === 'function') {
            this.modalInstance.setParams({ onAfterClose: this.props.onAfterClose });
        }

        if (this.props.open) {
            this.modalInstance.open();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            if (nextProps.open === true) {
                this.openModal();
            } else {
                this.closeModal();
            }
        }

        return false;
    }

    _callbackOnClose() {
        this.props.onClose();
    }

    openModal() {
        this.props.onOpen();
        this.modalInstance.open();
    }

    closeModal() {
        this.modalInstance.close();
    }

    render() {
        return (
            <AddToBody>
                <div
                    ref={node => {
                        this.node = node;
                    }}
                    className="spark-modal"
                    onClick={event => {
                        if (
                            event.target.className === 'spark-modal__scroll' ||
                            event.target.className === 'spark-modal'
                        ) {
                            this.props.onClose();
                        }
                    }}
                >
                    <div className="spark-modal__scroll">
                        <div className={`spark-modal__content col-xs-12 col-sm-10 ${this.props.className}`}>
                            <div
                                className={classNames('spark-modal__body', {
                                    'no-left-right-bottom-padding': this.props.genericPropertyValueModal
                                })}
                            >
                                {this.props.hideCloseButton ? null : (
                                    <a
                                        onClick={this.props.onClose}
                                        className="spark-modal__close spark-icon-close"
                                        title="Close Modal"
                                    />
                                )}
                                <div className="row">
                                    <div className="col-xs-12">{this.props.children}</div>
                                    <div className="col-xs-12">
                                        <nav
                                            className={classNames('spark-btn-group spark-margin-top-6', {
                                                'top-box-shadow': this.props.genericPropertyValueModal
                                            })}
                                        >
                                            {this.props.previousButton && (
                                                <a
                                                    className="spark-btn--previous"
                                                    onClick={this.props.previousButtonClick}
                                                >
                                                    <i className="spark-icon-arrow-basic-left" />
                                                    {this.props.previousButtonTitle}
                                                </a>
                                            )}
                                            {this.props.secondaryButton && (
                                                <button
                                                    className={`spark-btn spark-btn--${this.props.buttonSize} spark-btn--secondary spark-btn-group-secondary`}
                                                    onClick={
                                                        this.props.secondaryButtonClick === 'close'
                                                            ? this.closeModal
                                                            : this.props.secondaryButtonClick
                                                    }
                                                >
                                                    {this.props.secondaryButtonTitle}
                                                </button>
                                            )}
                                            {this.props.primaryButton && (
                                                <button
                                                    className={`spark-btn spark-btn--${this.props.buttonSize} spark-btn-group-primary`}
                                                    disabled={this.props.primaryButtonDisabled}
                                                    onClick={
                                                        this.props.primaryButtonClick === 'close'
                                                            ? this.closeModal
                                                            : this.props.primaryButtonClick
                                                    }
                                                >
                                                    {this.props.primaryButtonTitle}
                                                </button>
                                            )}
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AddToBody>
        );
    }
}

ReactSparkModal.propTypes = {
    // in Spark.Modal to handle close on "X" or click outside the modal
    // is needed to be able to notify us if modal is closed
    children: PropTypes.element,
    className: PropTypes.string,
    contenttype: PropTypes.string,
    onAfterClose: PropTypes.func,
    onBeforeClose: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    openByClickOn: PropTypes.element,
    primaryButton: PropTypes.bool,
    primaryButtonClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(['close'])]),
    primaryButtonTitle: PropTypes.string,
    primaryButtonDisabled: PropTypes.bool,
    secondaryButton: PropTypes.bool,
    secondaryButtonClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(['close'])]),
    secondaryButtonTitle: PropTypes.string,
    previousButton: PropTypes.bool,
    previousButtonClick: PropTypes.func,
    previousButtonTitle: PropTypes.string,
    buttonSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    hideCloseButton: PropTypes.bool
};

ReactSparkModal.defaultProps = {
    className: '',
    open: false,
    onClose: () => {},
    onOpen: () => {},
    primaryButton: false,
    secondaryButton: false,
    previousButton: false,
    buttonSize: 'md',
    hideCloseButton: false
};

export default ReactSparkModal;



// WEBPACK FOOTER //
// ./src/components/helpers/CTModal.js